import CircleItem from "./circleitem";
import CircleView from "./circleview";
import EaringItem from "./earingitem";

var stones;
var view;
var categoryType;

var EARING_TYPE = 7; // Khuyên tai

class DragDropHandler {
  constructor(v, items, type) {
    view = v;
    stones = [];
    categoryType = type;

    if (items) {
      [].forEach.call(
        items,
        function(img) {
          this.registerDrag(img);
        },
        this
      );
    }
    view.container.addEventListener("dragenter", this.handleDragEnter, false);
    view.container.addEventListener("dragover", this.handleDragOver, false);
    view.container.addEventListener("dragleave", this.handleDragLeave, false);
    view.container.addEventListener("drop", this.handleDrop, false);
  }

  registerListeners(v) {
    view = v;
    view.container.addEventListener("dragenter", this.handleDragEnter, false);
    view.container.addEventListener("dragover", this.handleDragOver, false);
    view.container.addEventListener("dragleave", this.handleDragLeave, false);
    view.container.addEventListener("drop", this.handleDrop, false);
  }

  registerDrag(item) {
    item.img.addEventListener("dragstart", this.handleDragStart, false);
    item.img.addEventListener("dragend", this.handleDragEnd, false);

    item.img.addEventListener("touchstart", this.handleDragStart, false);
    item.img.addEventListener("touchend", this.handleDrop, false);

    stones.push(item);
  }

  unregisterDrag(item) {
    item.img.removeEventListener("dragstart", this.handleDragStart, false);
    item.img.removeEventListener("dragend", this.handleDragEnd, false);

    item.img.addEventListener("touchstart", this.handleDragStart, false);
    item.img.addEventListener("touchend", this.handleDrop, false);

    let i = stones.indexOf(item);
    if (i >= 0) {
      stones.splice(i, 1);
    }
  }

  handleDragStart(e) {
    [].forEach.call(stones, function(item) {
      item.img.classList.remove("img_dragging");
    });
    this.classList.add("img_dragging");
  }

  handleDragOver(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }

    return false;
  }

  handleDragEnter(e) {
    this.classList.add("over");
  }

  handleDragLeave(e) {
    this.classList.remove("over");
  }

  handleDrop(e) {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    // if (e.stopPropagation) {
    //   e.stopPropagation();
    // }

    if (view.animating) {
      return false;
    }

    let drawWrap = document.getElementById("draw_tool_parent");

    var img = document.querySelector("img.img_dragging");
    var y = e.offsetY
      ? e.offsetY
      : e.changedTouches[0].pageY - drawWrap.offsetTop;
    var x = e.offsetX
      ? e.offsetX
      : e.changedTouches[0].pageX - drawWrap.offsetLeft;

    // check touch mobile
    if (!e.offsetX) {
      var elm = document.getElementById("wrap_draw_tool");

      if (y > elm.offsetHeight || y < 0 || x > elm.offsetWidth || x < 0) {
        return false;
      }
    }

    if (categoryType === EARING_TYPE) {
      let angle = view.pos2Angle({ x: x, y: y }, view.center);
      let tmp = stones.find(function(o) {
        return o.img === img;
      });
      var item = new EaringItem(
        tmp.sizeID,
        tmp.imageURL,
        img.naturalWidth,
        tmp.size,
        tmp.productID,
        tmp.productType,
        angle
      );
      item.updateSizes(img.naturalWidth, img.naturalHeight);
      var newImage = new fabric.Image(img, {
        scaleX: item.scale,
        scaleY: item.scale,
        _left: x,
        get left() {
          return this._left;
        },
        set left(value) {
          this._left = value;
        },
        top: y,
        hasBorders: false,
        hasControls: false
      });
      item.img = newImage;
      view.insertItem(item, { x: x, y: y });
    } else {
      let angle = view.pos2Angle(
        {
          x:
            x -
            (view.FabricCanvas.viewportTransform[4] +
              (view.FabricCanvas.width * view.FabricCanvas.getZoom() -
                view.FabricCanvas.width) /
                2),
          y:
            y -
            (view.FabricCanvas.viewportTransform[5] +
              (view.FabricCanvas.height * view.FabricCanvas.getZoom() -
                view.FabricCanvas.height) /
                2)
        },
        view.center
      );
      let tmp = stones.find(function(o) {
        return o.img === img;
      });

      var item = new CircleItem(
        tmp.sizeID,
        tmp.imageURL,
        img.naturalWidth,
        tmp.size,
        tmp.productID,
        tmp.productType,
        angle,
        view.r,
        tmp.hookPos
      );
      item.updateSizes(img.naturalWidth, img.naturalHeight);

      var newImage = new fabric.Image(img, {
        scaleX: item.scale,
        scaleY: item.scale,
        left: x,
        top: y,
        hasBorders: false,
        hasControls: false
      });
      item.img = newImage;
      view.insertItem(angle, item, {
        x:
          (x - view.FabricCanvas.viewportTransform[4]) /
          view.FabricCanvas.getZoom(),
        y:
          (y - view.FabricCanvas.viewportTransform[5]) /
          view.FabricCanvas.getZoom()
      });
    }
    return false;
  }

  handleDragEnd(e) {
    if (stones) {
      [].forEach.call(stones, function(item) {
        item.img.classList.remove("img_dragging");
      });
    }
  }
}

export default DragDropHandler;
